import { useEffect, useRef, useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { IDetail, ISearchFields, Service } from './service'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { message } from 'antd'
import { convertRes2Blob } from '@/utils/exportFile'

export const baseModel = createModel(function() {
    /**
     * 列表
     */
        //列表数据源
    const [dataSource, setDataSource] = useState<IDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<ISearchFields>({})
    //新增详情form
    const [detailAddForm, setDetailAddForm] = useState<IDetail>({})
    //编辑详情form
    const [detailEditForm, setDetailEditForm] = useState<IDetail>({})
    //详情form
    const [detailForm, setDetailForm] = useState<IDetail>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<IDetail[]>([])
    const [SelectedId, setSelectedId] = useState('')

    //新增，编辑状态判断
    const [mode, setMode] = useState<'add' | 'edit' | 'detail'>('add')
    //打开页面
    const [addVisible, setAddVisible] = useState(false)
    const [editVisible, setEditVisible] = useState<any>({
        visible: false,
        value: {}
    })
    const [detailVisible, setDetailVisible] = useState<any>({
        visible: false,
        value: {}
    })

    const pgCfgRef = useRef<TablePaginationConfig>(initPgCfg)
    //新增详情form
    const [totalNum, setTotalNum] = useState<any>({})
    const {
        user: { shopCode, createUser, userType },
        fetchVehicleList
    } = useGlobalModel(({ user }) => [user])
    const [loading, setLoading] = useState<boolean>(false)
    useEffect(() => {
        pgCfgRef.current = pgCfg
    }, [pgCfg])

    const [needReceiptList, setNeedReceiptList] = useState<string[]>(['需要回执', '无需回执'])
    const [noticeStatusList] = useState<{ name: string, value: string }[]>([
        { name: '草拟', value: 'Draft' },
        { name: '已发布', value: 'Published' }])
    const getStatusName = (status: string) => {
        return noticeStatusList.find(item => item.value === status)?.name || ''
    }

    const [driverList, setDriverList] = useState<any>([])
    const getDriverList = async () => {
        const params = {
            pageSize: -1,
            pageNum: 1,
            createUserId: shopCode,
            fleet: userType === '管理员' ? createUser : undefined
        }
        let { retData } = await Service.driverList(params)
        let list =
            retData.records.map((item) => ({
                label: item.driverName,
                value: item.id,
                fleet: item.fleet,
                type: item.type,
                isChecked: false
            })) || []
        setDriverList(list)
    }

    //列表查询
    const loadData = async (page: ISearchPage = pgCfgRef.current, searchValue: ISearchFields = searchParam) => {
        setLoading(true)

        const searchParams = {
            ...searchValue,
            createUser: userType === '管理员' || userType === '超级管理员' ? createUser : undefined,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? DEFAULT_FIRST_PAGE_NUM
        }
        let { retData } = await Service.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
        setLoading(false)
        fetchVehicleList()
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ISearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    //重置搜索参数
    const resetSearchParam = async () => {
        setSearchParam({})
        setSelectedRowKeys([])
        await loadData(initPgCfg, {})
    }

    const handlePublish = async (record: IDetail) => {
        let status: string = ''
        noticeStatusList.forEach((item) => {
            if (item.name === '已发布') {
                status = item.value
            }
        })
        await Service.publish({ id: record.id, status })
        message.success('发布成功!')
        await loadData()
    }

    const handleExport = (ids: string[]) => {
        ids.forEach(async (item: string) => {
            let response = await Service.exportPDF(item)
            convertRes2Blob(response);
        })
    }

    const setItemColor = (status: string) => {
        const name = getStatusName(status)

        switch (name) {
            case '草拟':
                return 'yellow-text'
            case '已发布':
                return 'blue-text'
            case '已完成':
                return 'green-text'
            case '已撤回':
                return 'red-text'
            default:
                return ''
        }
    }

    const initForm = () => {
        let form = {
            id: undefined,
            startTime: '',
            endTime: '',
            announcementUser: '',
            announcementUserList: [],
            title: '',
            createUser: '',
            content: '',
            onlineAnnouncementDetailsList: [],
            meetingType: '',
            meetingMode: ''
        }
        if (mode === 'add') {
            setDetailEditForm(form)
        }
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        detailVisible,
        addVisible,
        editVisible,
        detailEditForm,
        detailAddForm,
        detailForm,
        mode,
        SelectedId,
        totalNum,
        loading,
        initPgCfg,
        needReceiptList,
        noticeStatusList,
        driverList,
        /***method***/
        setEditVisible,
        setAddVisible,
        setLoading,
        setTotalNum,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setDetailVisible,
        setDetailEditForm,
        setDetailAddForm,
        setDetailForm,
        setMode,
        setSelectedId,
        setNeedReceiptList,
        setDriverList,
        handlePublish,
        handleExport,
        setItemColor,
        initForm,
        getDriverList,
        getStatusName
    }
})
